import { useMemo } from "react";

interface UsePopoverPositionParams {
	bbox: { left: number; top: number; width: number; height: number };
	canvasSize: { width: number; height: number };
	panelWidth: number;
	estimatedHeight: number;
}

/**
 * Calculates the { left, top } position for a floating panel anchored
 * to an object bounding box inside the canvas.
 * Prefers the right side of the bbox; falls back to the left if it would overflow.
 * Clamps to canvas edges with padding on all sides.
 */
export const usePopoverPosition = ({ bbox, canvasSize, panelWidth, estimatedHeight }: UsePopoverPositionParams) => {
	return useMemo(() => {
		const PAD = 10;
		const GAP = 8;

		const fitsRight = bbox.left + bbox.width + GAP + panelWidth <= canvasSize.width - PAD;
		const x = fitsRight ? bbox.left + bbox.width + GAP : bbox.left - panelWidth - GAP;

		return {
			left: Math.max(PAD, Math.min(x, canvasSize.width - panelWidth - PAD)),
			top: Math.max(PAD, Math.min(bbox.top, canvasSize.height - estimatedHeight - PAD)),
		};
	}, [bbox, canvasSize, panelWidth, estimatedHeight]);
};
